import { useMutation } from '@apollo/client';
import {
    UpdateWorldMap,
    UpdateWorldMapVariables
} from 'graphql/mutation/__generated__/UpdateWorldMap';
import { UPDATE_WORLD_MAP_MUTATION } from 'graphql/mutation/worldMutation';
import { useWorldMapLocalStorage } from 'libs/hooks/ownership/useWorldMapLocalStorage';
import { EColors, EFonts, EHovers } from 'libs/styles/styling';
import { useContext, useEffect, useState } from 'react';
import { CtxEdit } from 'session/ctxEdit';
import styled from 'styled-components/macro';
import { useDebounce } from 'usehooks-ts';

interface Props {
    className?: string;
}

export const HeaderCenter = (props: Props): JSX.Element => {
    const ctxEdit = useContext(CtxEdit);
    const { getTokenForMapId } = useWorldMapLocalStorage();
    const [value, setValue] = useState<string>(ctxEdit.map?.title ?? '');
    const debouncedValue = useDebounce(value, 1000);

    const [updateWorld] = useMutation<UpdateWorldMap, UpdateWorldMapVariables>(
        UPDATE_WORLD_MAP_MUTATION
    );

    useEffect(() => {
        if (ctxEdit.map?.title !== value) {
            setValue(ctxEdit.map?.title);
        }
    }, [ctxEdit.map?.title]);

    useEffect(() => {
        if (debouncedValue === ctxEdit.map?.title || !ctxEdit.map?.worldMapId) return;
        updateWorld({
            variables: {
                worldMapId: ctxEdit.map?.worldMapId,
                token: getTokenForMapId(ctxEdit.map?.worldMapId),
                map: {
                    title: debouncedValue
                }
            }
        });
        ctxEdit.setMap({ ...ctxEdit.map, title: debouncedValue });
    }, [debouncedValue]);

    if (!ctxEdit.map?.worldMapId) {
        return null;
    }

    return (
        <S_HeaderCenter className={props.className}>
            <S_InputContainer>
                <S_Input
                    value={value ?? ''}
                    onChange={(e) => {
                        setValue(e.target.value);
                    }}
                    placeholder={'Name this map'}
                    multiple={false}
                />
            </S_InputContainer>
            {/* <S_MapViewsCounter /> */}
        </S_HeaderCenter>
    );
};

const S_HeaderCenter = styled.div`
    width: 100%;
    position: relative;
`;

const S_InputContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    position: relative;
`;

const S_Input = styled.input`
    width: 250px;
    padding: 5px 180px;
    outline: 0;
    border: 0;
    text-align: center;
    background-color: transparent;
    font-size: 16px;
    color: ${EColors.WHITE};
    font-family: ${EFonts.Medium};
    &::placeholder {
        color: rgba(255, 255, 255, 0.5);
    }
    &:hover,
    &:focus {
        box-shadow: ${EHovers.LIGHT1};
    }
`;

// const S_MapViewsCounter = styled(MapViewsCounter)`
//     position: absolute;
//     top: 0;
//     right: 0;
// `;
